import { awsService } from '@/api/aws';

const getFileNameFromUrl = (url: string): string => {
	const pathname = new URL(url).pathname;
	return pathname.split('/').pop() || 'image';
};

export const urlToFile = async (url: string): Promise<File | undefined> => {
	try {
		const fileName = getFileNameFromUrl(url);
		// if it's a claimmagic url, get the file from aws
		let path = url;
		if (url.includes('claimmagic')) {
			path = new URL(url).pathname.slice(1);
			const res = await awsService.getFileByPath(path);
			const contentType = res.type || 'image/jpeg';
			return new File([res], fileName, { type: contentType });
		}
		// if it's a regular url, fetch the file
		const response = await fetch(url);
		if (!response.ok) {
			throw new Error('Could not get image from provided URL');
		}
		const blob = await response.blob();
		const contentType = response.headers.get('content-type') || 'image/jpeg';
		return new File([blob], fileName, { type: contentType });
	} catch (error) {
		console.log('Error fetching image:', error);
	}
};
